import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa6';
import './HeaderStyle.css';

function Header() {
    return (
        <header className='intro-contenedor'>
            <div className='intro-datos-personales'>
                <h1>Noemí Armengod</h1>
                <h2>Desarrolladora WordPress y gestora de proyectos digitales</h2>
                <p><a href="mailto:narmengod@gmail.com">narmengod@gmail.com</a></p>
                <div className='iconos-rrss'>
                    <a href="https://www.linkedin.com/in/noemiarmengod/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                    <a href="https://github.com/NoemiArmengod" target="_blank" rel="noreferrer"><FaGithub /></a>
                </div>
            </div>
        </header>
    )
}

export default Header;